import { defineComponent } from 'vue';
import { QUESTION_TYPE, value2label } from '@/utils';
export default defineComponent({
  name: 'QuestionTypeHeader',
  props: {
    questionTypeId: {
      type: Number,
      required: true
    },
    index: {
      type: [Number, String],
      default: '--'
    },
    totalNum: {
      type: [Number, String],
      default: '--'
    },
    totalScore: {
      type: [Number, String],
      default: '--'
    }
  },
  setup: function () {
    return {
      QUESTION_TYPE: QUESTION_TYPE,
      value2label: value2label
    };
  }
});